import { render, staticRenderFns } from "./Cuenta.vue?vue&type=template&id=57674614&scoped=true"
import script from "./Cuenta.vue?vue&type=script&lang=js"
export * from "./Cuenta.vue?vue&type=script&lang=js"
import style0 from "./Cuenta.vue?vue&type=style&index=0&id=57674614&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57674614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57674614')) {
      api.createRecord('57674614', component.options)
    } else {
      api.reload('57674614', component.options)
    }
    module.hot.accept("./Cuenta.vue?vue&type=template&id=57674614&scoped=true", function () {
      api.rerender('57674614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/cuenta/Cuenta.vue"
export default component.exports